// extracted by mini-css-extract-plugin
module.exports = {"landingContainer":"RegisterButton_landingContainer__U9KAS","btn":"RegisterButton_btn__aNLV_"};